import { useMap } from "context/mapContext";
import React from "react";

function MainMap() {
  const [map] = useMap();
  const { mapDiv } = map;

  return <div style={{ height: "100%" }} className="mapDiv" ref={mapDiv} />;
}

export default MainMap;
